function initLeafletMap({ containerId, center, zoom, markers }) {
  delete L.Icon.Default.prototype._getIconUrl;

  L.Icon.Default.mergeOptions({
    iconRetinaUrl: "/marker-icon-2x.png",
    iconUrl: "/marker-icon.png",
    shadowUrl: "/marker-shadow.png",
  });

  // 1. Create Leaflet map
  const map = L.map(containerId).setView(center, zoom);

  // 2. Add tile layer (OpenStreetMap)
  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
  }).addTo(map);

  // 3. Add markers
  markers.forEach((m) => {
    // Create marker at lat/lng
    const marker = L.marker([m.lat, m.lng], {
      title: m.title, // browser tooltip on hover
    }).addTo(map);

    // Bind a tooltip (text on hover)
    if (m.tooltipText) {
      marker.bindTooltip(m.tooltipText /* content */, {
        // options:
        direction: 'top',
        permanent: m.tooltipPermanent || false,
      });

      // Optionally open tooltip immediately
      if (m.openTooltip) {
        marker.openTooltip();
      }
    }

    // Bind a popup (click)
    if (m.popupHtml) {
      marker.bindPopup(m.popupHtml);
    }

    // Optional: custom click behavior
    if (typeof m.onClick === 'function') {
      marker.on('click', m.onClick);
    }
  });

  return map;
}

$(function () {
  if (document.getElementById('map')) {
    initLeafletMap({
      containerId: 'map',
      center: [48.589, 7.749],
      zoom: 15,
      markers: JSON.parse(document.getElementById('map').dataset['building']).map(([lat, lng, name, roomCount, fullAddress]) => ({
        lat,
        lng,
        title: name,
        popupHtml: '<div><p>' + name + '<br />' + fullAddress + '<br />nombre de chambres: ' + roomCount + '</p></div>',
      })),
    })
  }
  $("select.select2").select2();

  $('.datepicker').inputmask("date", { "placeholder": "jj/mm/aaaa" });

  $('div[id^="description_"]').on('shown.bs.collapse', function () {
    $('[data-target="#' + $(this).attr('id') + '"').text('Voir moins');
  });

  $('div[id^="description_"]').on('hidden.bs.collapse', function () {
    $('[data-target="#' + $(this).attr('id') + '"').text('En savoir plus');
  });

  var csrf_token = $('meta[name=csrf-token]').attr('content');
  var csrf_param = $('meta[name=csrf-param]').attr('content');
  var params;
  if (csrf_param !== undefined && csrf_token !== undefined) {
    params = csrf_param + "=" + encodeURIComponent(csrf_token);
  }
  $('.redactor').redactor(
    {
      'imageUpload': '/attachments?' + params,
      "path": "/assets/ideematic-redactor",
      "css": "style.css",
      "minHeight": '400',
      xhtml: true,
      mobile: false,
      tidyHtml: false,
      cleanup: false,
      "convertDivs": false,
      "paragraphy": true,
      removeEmptyTags: true,
      "allowedTags": ['p', 'blockquote', 'pre', 'h2', 'h3', 'h4', 'h5', 'div', 'ul', 'li', 'a', 'img', 'br', 'hr', 'ol', 'b', 'strong', 'span', 'table', 'th', 'tr', 'td', 'thead', 'tbody', 'tfoot']
    }
  );

  $('table:not([class])').addClass('table table-hover zebra').find('thead').addClass('bg-aqua');

  $('a[data-turbolinks="false"]').click(function () {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 60
        }, 1000);
        return false;
      }
    }
  });

  $('.js-slugify').on('change', function (e) {
    value = $(this).val().toLowerCase().replace(/-+/g, '').replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    $(this).val(value);
  });

  if ($('.custom_field_allow_multiple select').find(':selected').val() == 0) {
    $('.custom_field_max_values').css('display', 'none');
  }
  $('.custom_field_allow_multiple select').on('change', function () {
    if ($(this).find(':selected').val() == 1) {
      $('.custom_field_max_values').fadeIn(300);
    } else {
      $('.custom_field_max_values').fadeOut(300).find('input').val('').attr('value', '');
    }
  });

  if ($('#step_id[value="4"]').length) {
    var input = $('input[type="radio"][class^="radio_buttons"]');
    var checked = $('input[type="radio"][class^="radio_buttons"]:checked');
    if (checked.val() == 'Oui' || input.val() == undefined) {
      $('[class="form-group"]:not(:first-child)').css('display', 'block');
    } else {
      $('[class="form-group"]:not(:first-child)').css('display', 'none');
    }
    input.on('change', function () {
      if ($(this).val() == 'Oui') {
        $('[class="form-group"]:not(:first-child)').fadeIn(300);
      } else {
        $('[class="form-group"]:not(:first-child)').fadeOut(300);
      }
    });
  }

  if ($('#group_6').length) {
    if ($('#group_6 [class="form-group"]:first-child').find('p:not(:empty)').text() == "Non" || $('#group_6 [class="form-group"]:first-child').find('small:not(:empty)').length) {
      $('#group_6 [class="form-group"]:not(:first-child)').css('display', 'none');
    }
  }

  if ($('#admissionFileSelect').length) {
    $('.js-container').off('click').on('click', '#admissionFileSelect.btn-default', function (e) {
      e.preventDefault();
      $(this).text('Archiver').prepend('<i class="fa fa-archive"></i>&nbsp;').removeClass('btn-default').addClass('btn-primary');
      $(this).after('<a id="admissionFileCancel" class="btn btn-default" style="margin-left: 10px;"><i class="fa fa-cancel"></i>Annuler</a>');
      var archivableRows = $('tr[data-state="paid"], tr[data-state="paid_other"], tr[data-state="pending"], tr[data-state="canceled"], tr[data-state="comission"], tr[data-state="enabled"], tr[data-state="completed"], tr[data-state="incompleted"]');
      var rows = $('.js-admission-files-container tr');
      var ids = [];
      $('#admissionFileTable').find('thead tr').prepend('<th></th>');

      rows.each(function () {
        $(this).prepend('<td></td>');
      });

      archivableRows.each(function () {
        $(this).find('td:first-child').prepend('<a class="btn btn-xs btn-primary js-archive-btn"><i class="fa fa-plus"></i>&nbsp;Sélectionner</a>');
      });

      archivableRows.on('click', function (e) {
        e.preventDefault();
        if (!$(this).hasClass('js-admission-file-selected')) {
          $(this).toggleClass('js-admission-file-selected');
          $(this).find('.js-archive-btn').text('Sélectionné').prepend('<i class="fa fa-check"></i>&nbsp;');
          ids.push($(this).data('id'));
        } else {
          $(this).toggleClass('js-admission-file-selected');
          $(this).find('.js-archive-btn').text('Sélectionner').prepend('<i class="fa fa-plus"></i>&nbsp;');
          var index = ids.indexOf($(this).data('id'));
          ids.splice(index, 1);
        }
      });

      $('#admissionFileSelect.btn-primary').off('click').on('click', function () {
        $.ajax({
          url: '/admin/admission_files/archive_many',
          type: 'post',
          data: { ids: ids }
        });
      });

      $('#admissionFileCancel').on('click', function (e) {
        e.preventDefault();
        $('#admissionFileSelect').remove();
        $(this).before('<a class="btn btn-default" id="admissionFileSelect"><i class="fa fa-archive"></i>&nbsp;Archiver plusieurs dossiers</a>');
        archivableRows.off('click');
        $('#admissionFileTable').find('thead tr th:first-child').remove();
        rows.each(function () {
          $(this).find('td:first-child').remove();
          $(this).removeClass('js-admission-file-selected');
        });
        $('#admissionFileSelect.btn-primary').text('Archiver plusieurs dossiers').prepend('<i class="fa fa-archive"></i>&nbsp;').removeClass('btn-primary').addClass('btn-default');
        ids = [];
        $(this).fadeOut(300, function () {
          $(this).remove();
        });
      });
    });
  }

  if ($('#contactModal').length) {
    $('#contactModal').on('show.bs.modal', function (e) {
      $(this).find('h4').text('Contacter').append("&nbsp;" + $(e.relatedTarget).data('name'));
      $(this).find('#email_af_id').attr('value', $(e.relatedTarget).closest('tr').data('id'));
    });
  }

  function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  if ($('.js-sort-by-seniority').length) {
    sortBySeniorityLink = $('.js-sort-by-seniority');
    sortBySeniorityLink.on('click', function (e) {
      e.preventDefault();
      urlParamValue = getParameterByName('sort_by_seniority');
      linkParamValue = getParameterByName('sort_by_seniority', $(this).attr('href'));
      namespace = $(this).data('namespace');
      if (urlParamValue == linkParamValue) {
        linkParamValue == 'desc' ? newValue = 'asc' : newValue = 'desc';
        $(this).attr('href', '/' + namespace + '/admission_files?sort_by_seniority=' + newValue);
      }
      window.location.href = $(this).attr('href')
    });

    urlParamValue = getParameterByName('sort_by_seniority');
    if (urlParamValue !== null) {
      urlParamValue == 'desc' ? sortBySeniorityLink.append('&nbsp;▼') : sortBySeniorityLink.append('&nbsp;▲')
    }
  }

  var sortableHelper = function (e, ui) {
    ui.children().each(function () {
      $(this).width($(this).width());
    });
    return ui;
  };

  $('#pages').sortable({
    axis: "y",
    helper: sortableHelper,
    stop: function (event, ui) {
      var token = $('meta[name="csrf-token"]').attr('content')
      var serialized = $("#pages").sortable('serialize')

      $.post('/admin/interests/order', '_method=post&authenticity_token=' + token + '&' + serialized)
    }
  }).disableSelection();

  window.rating_select = {
    init: function () {
      $('.rating_select').on('click', this.on_click);
    },

    on_click: function (e) {
      $('.rating_select').removeClass('disabled').parent().removeClass('bg-success disabled');
      const self = $(e.currentTarget);
      self.addClass('disabled');
      self.parent().addClass('bg-success disabled');
      $('.rating_select_input').val(self.data('val'));
    }
  };

  window.building_select = {
    init: function () {
      $('.building_select').on('click', this.on_click);
    },

    on_click: function (e) {
      $('.building_select').removeClass('disabled').parent().removeClass('bg-success disabled');
      const self = $(e.currentTarget);
      self.addClass('disabled');
      self.parent().addClass('bg-success disabled');
      $('.building_select_input').val(self.data('val'));
    }
  };

  // rating select
  window.rating_select.init();
  window.building_select.init();
});
